import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  creation: {
    qualifications: [],
    originalData: null,
  },
  update: {
    qualifications: [],
    hasChanges: false,
  },
  display: {
    qualifications: [],
    loading: false,
    error: null,
  },
};

const qualificationSlice = createSlice({
  name: "qualification",
  initialState,
  reducers: {
    // Creation actions
    updateCreationQualifications: (state, action) => {
      state.creation.qualifications = action.payload;
    },
    addCreationQualification: (state, action) => {
      state.creation.qualifications.push(action.payload);
    },
    removeCreationQualification: (state, action) => {
      state.creation.qualifications = state.creation.qualifications.filter(
        (q) => q.id !== action.payload,
      );
    },
    resetCreation: (state) => {
      state.creation = initialState.creation;
    },
    loadCreationData: (state, action) => {
      state.creation.qualifications = action.payload || [];
    },
    setCreationOriginalData: (state, action) => {
      state.creation.originalData = action.payload;
    },

    // Update actions
    updateUpdateQualifications: (state, action) => {
      state.update.qualifications = action.payload;
      state.update.hasChanges = true;
    },
    addUpdateQualification: (state, action) => {
      state.update.qualifications.push(action.payload);
      state.update.hasChanges = true;
    },
    removeUpdateQualification: (state, action) => {
      state.update.qualifications = state.update.qualifications.filter(
        (q) => q.id !== action.payload,
      );
      state.update.hasChanges = true;
    },
    loadUpdateData: (state, action) => {
      state.update.qualifications = action.payload;
      state.update.hasChanges = false;
    },
    clearUpdateChanges: (state) => {
      state.update.hasChanges = false;
    },
    resetUpdate: (state) => {
      state.update = initialState.update;
    },

    // Display actions
    setDisplayData: (state, action) => {
      state.display.qualifications = action.payload;
      state.display.loading = false;
      state.display.error = null;
    },
    setDisplayLoading: (state, action) => {
      state.display.loading = action.payload;
    },
    setDisplayError: (state, action) => {
      state.display.error = action.payload;
      state.display.loading = false;
    },
    resetDisplay: (state) => {
      state.display = initialState.display;
    },
  },
});

export const {
  updateCreationQualifications,
  addCreationQualification,
  removeCreationQualification,
  loadCreationData,
  setCreationOriginalData,
  updateUpdateQualifications,
  addUpdateQualification,
  removeUpdateQualification,
  loadUpdateData,
  clearUpdateChanges,
  resetCreation,
  resetUpdate,
  setDisplayData,
  setDisplayLoading,
  setDisplayError,
  resetDisplay,
} = qualificationSlice.actions;

export default qualificationSlice.reducer;
